import { QuestionPlanDiscountConnectionRoot as Root } from "@/components/features/items/edit/plan/_shared/ui/components/connection/discount-connection";

import { QuestionPlanDefaultDiscount } from "./default-discount-id";
import { QuestionPlanDiscountConnection } from "./discount-connection";
import { usePlanDiscountConnectionRoot } from "./hooks";

export const QuestionPlanDiscountConnectionRoot = () => {
	const { canShowDiscountConnection } = usePlanDiscountConnectionRoot();

	return (
		<Root>
			<QuestionPlanDefaultDiscount />
			{canShowDiscountConnection ? <QuestionPlanDiscountConnection /> : null}
			<div className="ml-6 rounded-md border bg-zinc-50 p-3">
				<p className="text-sm text-zinc-600">
					<b>優先順位について:</b>
					<br />
					このプランで「適用可能なディスカウント」を選択していても、各ディスカウント設定側で適用対象にチェックが入っていない場合は、ディスカウントの適用はされません。
					<br />
					※このプランに紐付けている部屋・オプションに対して個別にディスカウントの設定を行いたい場合は、ディスカウントの紐付けを行ってください。
					<br />
					またこのプランのみをディスカウントから除外したい場合は、ディスカウント編集画面の「ディスカウントの対象」からプランのみチェックを外してください。
				</p>
			</div>
		</Root>
	);
};

QuestionPlanDiscountConnectionRoot.displayName = "QuestionPlanDiscountConnectionRoot";
